module.exports = __webpack_public_path__ + "static/sport/out5.cb367a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/out5.png
// module id = FIBf
// module chunks = 0